import React from 'react';
import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import EnumControl from './EnumControl';
import InputControl from './InputControl';

const ArrayControl = ({ attr, typeSpec, disabled }: { attr: string; typeSpec: TypeSpec; disabled: boolean }) => {
  if (typeSpec.enum) {
    return <EnumControl attr={attr} typeSpec={typeSpec} disabled={disabled} />;
  }

  return <InputControl attr={attr} typeSpec={typeSpec} disabled={disabled} />;
};

export default ArrayControl;
